export class User {
    jid: string;
    name: string;
    email: string;
    photo: string;
    presence: string;
}

export class Roster {
    jid: string;
    name: string;
    lastText: string;
    photo: string;
}